/**
 * Confirmation result types for RMC order status checking
 * Defines the possible states after checking SAP for order request status
 */

/** Transaction result types including dispatch approval state */
export type TransactionResultType =
  | 'success'
  | 'pending'
  | 'failure'
  | 'pendingDispatch'
  | 'customerActionRequired'

/**
 * Order request status from backend API
 * Matches the existing OrderRequestStatus enum
 */
export enum OrderRequestStatus {
  Failed = 'failed',
  Pending = 'pending',
  Success = 'completed',
  NotValidated = 'notValidated',
  Sent = 'sent'
}
